import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ItemUnitsFilterEntity } from '../../domain/entities/ItemUnitsFilterEntity'

export class ItemUnitsFilterModel extends ItemUnitsFilterEntity {
  constructor(dataDto:  ItemUnitsFilterEntity) {
    super()
    mapEntityProperties<ItemUnitsFilterModel>(this, dataDto)
  }
}


 